import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'pm-manualorder',
  templateUrl: './manualorder.component.html',
  styleUrls: ['./manualorder.component.css']
})
export class ManualorderComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
